import { Injectable, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class MyVectronicTitleStrategy extends TitleStrategy {
  private readonly title = inject(Title);

  override updateTitle(snapshot: RouterStateSnapshot): void {
    const firstName = this.buildTitle(snapshot);
    const title = firstName
      ? firstName.charAt(0).toUpperCase() + firstName.slice(1)
      : 'My Vectronic';
    this.title.setTitle(title);
  }
}
